import { getBrandCar } from '@/selectors';
import * as connect from '@lib/azgaz-ui/connect';
import { useSelector } from 'react-redux';
import { State } from '../apps/appCreator/store';

/**
 * Возвращает автомобиль во специфичными для бренда расчетами
 */
export default function useBrandCar() {
  const car = connect.useSelector(connect.selectors.getCar);
  const brandCar = useSelector((state: State) => getBrandCar(state, car));

  return brandCar;
}
